<template>
    <div
        v-if="
            payhead &&
            !payhead.disableCompanyAndEmployeeEdits &&
            payheadMasters &&
            (companyPayheadValue ? companyPayheadValue.enabled : true) &&
            !payhead.isLeavePayhead
        "
        class="pvei-card"
    >
        <div class="pvei-header">
            <div class="pvei-name">{{ payhead.placeholderTitle || payhead.name }}</div>
            <div class="pvei-toggle" v-if="!payhead.isBasicSalary">
                <label class="pvei-switch" :for="`enabled_${payhead.id}`">
                    <input
                        :id="`enabled_${payhead.id}`"
                        type="checkbox"
                        v-model="enabled"
                    />
                    <span class="pvei-slider"></span>
                </label>
                <span :class="['pvei-toggle-label', { 'pvei-enabled': enabled }]">{{ enabled ? 'Enabled' : 'Disabled' }}</span>
            </div>
            <span v-else class="pvei-basic-badge">Basic Salary</span>
        </div>
        <div class="pvei-body" v-if="enabled || payhead.isBasicSalary">
            <div class="pvei-fields">
                <div class="pvei-field" v-if="!payhead.onlyAllowFlatRate && payheadMasters.calculationTypes">
                    <label class="pvei-field-label">Value Type</label>
                    <SelectDropdown
                        :id="`calculation_type_${payhead.id}`"
                        :options="payheadMasters.calculationTypes.map((item) => ({ id: item.id, title: item.name }))"
                        :value="selectedCalculationTypeId"
                        @change="selectedCalculationTypeId = $event"
                    />
                </div>
                <div
                    class="pvei-field"
                    v-if="
                        !payhead.onlyAllowFlatRate &&
                        selectedCalculationType &&
                        selectedCalculationType.isComputedValue
                    "
                >
                    <label class="pvei-field-label">Percentage</label>
                    <div class="pvei-input-wrap">
                        <input
                            class="pvei-input"
                            :class="{ 'pvei-input-error': percentage > 100 || percentage < 0 }"
                            v-model="percentage"
                            type="number"
                            placeholder="0"
                        />
                        <span class="pvei-input-suffix">%</span>
                    </div>
                </div>
                <div
                    class="pvei-field"
                    v-else-if="
                        !payhead.isOvertimePayhead &&
                        (payhead.onlyAllowFlatRate ||
                            (selectedCalculationType &&
                                !selectedCalculationType.isUserDefined &&
                                !selectedCalculationType.isComputedValue))
                    "
                >
                    <label class="pvei-field-label">Amount</label>
                    <div class="pvei-input-wrap">
                        <span class="pvei-input-prefix">₹</span>
                        <input
                            class="pvei-input pvei-input-has-prefix"
                            v-model="value"
                            type="number"
                            placeholder="0"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomInput from "../crud/custom-input.vue"
import SelectDropdown from "../crud/SelectDropdown.vue"

export default {
    data() {
        return {
            value: "",
            percentage: "",
            selectedCalculationTypeId: "",
            defaultCalculationType: "",
            enabled: true,
        }
    },
    emits: ["change"],
    props: {
        payheads: { type: Array, default: () => [] },
        payhead: { type: Object, default: () => null },
        payheadValue: { type: Object, default: () => null },
        payheadMasters: { type: Object, default: () => null },
        companyPayheadValue: { type: Object, default: () => null },
    },
    components: { CustomInput, SelectDropdown },

    mounted() {
        this.initialize()
    },
    methods: {
        initialize() {
            // Always resolve the flat-rate type as a safe default
            const flatRateType = this.payheadMasters && this.payheadMasters.calculationTypes
                ? this.payheadMasters.calculationTypes.find(
                      (item) => !item.isComputedValue && !item.isUserDefined
                  )
                : null

            this.defaultCalculationType = flatRateType

            if (this.payheadValue) {
                this.selectedCalculationTypeId = this.payheadValue.calculationTypeId
                this.percentage = this.payheadValue.percentage
                this.value = this.payheadValue.value
                this.enabled = this.payheadValue.enabled
            }

            // For Basic Salary: ensure a calculationType is always selected
            // so the Amount field renders and saves properly
            if (this.payhead.isBasicSalary && !this.selectedCalculationTypeId && flatRateType) {
                this.selectedCalculationTypeId = flatRateType.id
            }
        },
        emitUpdateData() {
            const formattedData = {
                payheadId: this.payhead.id,
                calculationTypeId:
                    this.selectedCalculationTypeId ||
                    (this.defaultCalculationType && this.defaultCalculationType.id),
                value: Number(this.value || 0),
                percentage: Number(this.percentage || 0),
                enabled: this.enabled,
            }

            this.$emit("change", {
                data: formattedData,
                payhead: this.payhead,
                selectedCalculationType:
                    this.selectedCalculationType || this.defaultCalculationType,
            })
        },
    },
    computed: {
        selectedCalculationType() {
            if (!this.payheadMasters || !this.payheadMasters.calculationTypes) return null
            return this.payheadMasters.calculationTypes.find((item) =>
                this.selectedCalculationTypeId
                    ? item.id == this.selectedCalculationTypeId
                    : (this.defaultCalculationType ? item.id == this.defaultCalculationType.id : false)
            )
        },
    },
    watch: {
        value(e) {
            this.emitUpdateData()
        },
        percentage(e) {
            this.emitUpdateData()
        },
        selectedCalculationTypeId(e) {
            this.emitUpdateData()
        },
        enabled(e) {
            this.emitUpdateData()
        },
        payheadValue: {
            handler() {
                this.initialize()
            },
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped>

@import "../../assets/variables.scss";

.pvei-card { background:white; border:1px solid $gray100; border-radius:10px; margin-bottom:10px; box-shadow:$shadowSm; transition:border-color $transitionFast; &:hover { border-color:$gray200; } }
.pvei-header { display:flex; align-items:center; justify-content:space-between; padding:12px 16px; border-bottom:1px solid $gray50; }
.pvei-name { font-size:14px; font-weight:700; color:$gray800; }
.pvei-basic-badge { font-size:10.5px; font-weight:600; padding:3px 10px; border-radius:$radiusFull; background:rgba(0,94,137,.08); color:$primaryColor; }

/* Toggle switch */
.pvei-toggle { display:flex; align-items:center; gap:8px; }
.pvei-toggle-label { font-size:12px; font-weight:500; color:$gray400; &.pvei-enabled { color:#059669; } }
.pvei-switch { position:relative; display:inline-block; width:36px; height:20px; cursor:pointer;
    input { opacity:0; width:0; height:0;
        &:checked + .pvei-slider { background:#059669; }
        &:checked + .pvei-slider:before { transform:translateX(16px); }
    }
}
.pvei-slider { position:absolute; inset:0; background:$gray200; border-radius:$radiusFull; transition:background $transitionFast;
    &:before { content:''; position:absolute; height:14px; width:14px; left:3px; bottom:3px; background:white; border-radius:$radiusFull; transition:transform $transitionFast; box-shadow:0 1px 2px rgba(0,0,0,.15); }
}

/* Body */
.pvei-body { padding:12px 16px; }
.pvei-fields { display:grid; grid-template-columns:1fr 1fr; gap:16px; }
.pvei-field { min-width:0; }
.pvei-field-label { display:block; font-size:11.5px; font-weight:600; color:$gray500; text-transform:uppercase; letter-spacing:.3px; margin-bottom:5px; }

/* Input with prefix/suffix */
.pvei-input-wrap { display:flex; align-items:center; border:1px solid $gray200; border-radius:8px; background:white; overflow:hidden; transition:border $transitionFast; &:focus-within { border-color:$primaryColor; box-shadow:0 0 0 2px rgba(0,94,137,.08); } }
.pvei-input-prefix { padding:7px 0 7px 10px; font-size:14px; color:$gray500; font-weight:500; }
.pvei-input-suffix { padding:7px 10px 7px 0; font-size:14px; color:$gray500; font-weight:500; }
.pvei-input { width:100%; padding:7px 10px; border:none; outline:none; font-size:13px; font-weight:500; color:$gray800; background:transparent; font-family:inherit; -moz-appearance:textfield; &::-webkit-outer-spin-button, &::-webkit-inner-spin-button { -webkit-appearance:none; margin:0; } &.pvei-input-has-prefix { padding-left:4px; } }
.pvei-input-error { color:#dc2626; }

@media(max-width:640px) {
    .pvei-fields { grid-template-columns:1fr; }
}
</style>
